import { render } from "./UserpageNavbar.vue?vue&type=template&id=184c94ac"
import script from "./UserpageNavbar.vue?vue&type=script&lang=js"
export * from "./UserpageNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__